import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, share } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthResponse } from '../shared/models/users/auth-response';
import { OtpUser } from '../shared/models/otp/otp-user';
import { SignIn } from '../shared/models/users/sign-in';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService {
  private readonly apiUrl = environment.apiurl + 'platform/auth';
  private logoutRequest: Observable<void> | null = null;

  constructor(private http: HttpClient) {}

  login(signIn: SignIn): Observable<number> {
    return this.http.post<number>(this.apiUrl, signIn);
  }

  validateOtp(otpUser: OtpUser): Observable<AuthResponse> {
    return this.http.post<AuthResponse>(`${this.apiUrl}/validate-otp`, otpUser, {
      withCredentials: true,
    });
  }

  resendOtp(userId: number): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/resend-otp?userId=${userId}`, null);
  }

  refresh(): Observable<AuthResponse> {
    return this.http.get<AuthResponse>(`${this.apiUrl}/refresh`, { withCredentials: true });
  }

  forgotPassword(email: string): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/forgot-password`, { email });
  }

  resetPassword(email: string, otp: string, newPassword: string): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/reset-password`, {
      email,
      otp,
      newPassword,
    });
  }

  setInitialPassword(passwordKey: string, password: string, confirmPassword: string): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/set-initial-password`, {
      passwordKey,
      password,
      confirmPassword,
    });
  }

  logout(): Observable<void> {
    if (!this.logoutRequest) {
      this.logoutRequest = this.http
        .post<void>(`${this.apiUrl}/logout`, null, { withCredentials: true })
        .pipe(
          finalize(() => {
            this.logoutRequest = null;
          }),
          share()
        );
    }
    return this.logoutRequest;
  }
}
